<template>
  <div>
    <n-bread
        v-bind:content="{bread_list, bread_active}"
    ></n-bread>
    <div class="card   abtg__default-card abtg__default-card-border">

      <div class="card-body ">
        <h3>Le caratteristiche del servizio</h3>
        <p>
          Il servizio "Atti di Vendita" consente, partendo dal centro del poligono disegnato, di trovare
          l'elenco
          degli immobili venduti in quella zona con il riferimento all'atto di vendita e al
          prezzo.

          È possibile impostare il raggio di azione che corrisponde alla distanza - dal centro del poligono - di ricerca
          degli immobili venduti.
        </p>

        <p>
          Il servizio restituisce le seguenti informazioni:
        </p>
        <ul>
          <li>Nome Zona Immobiliare</li>
          <li>Consistenza in mq</li>
          <li>Categoria Catastale</li>
          <li>Superficie commerciale</li>
          <li>Relativo prezzo al mq</li>
          <li>Prezzo Totale</li>
          <li>Mese di stipula atto</li>

        </ul>

        <h3>Aggiornamento</h3>
        <p>Le compravendite partono dal 2019. E l'aggiornamento del database è semestrale.</p>

        <h3>Costi</h3>
        <p>Il costo del servizio è pari ai <strong>risultati ottenuti</strong>: questo significa che il wallet digitale
          a tua disposizione scalerà i crediti SOLO se ci sono risultati nella zona (poligono) scelta.<br>
        Il costo di ogni singolo risultato è di <strong>n. {{price}} crediti</strong>.</p>



          <a href="/services/compravendita" class="text-center mt-2 btn btn-success abtg__btn-third shadow-none abtg-button-big">ACCEDI AL SERVIZIO</a>

<!--        <span v-else>-->
<!--          <a href="/services/wallet" class="text-center mt-2 btn btn-success abtg__btn-third shadow-none abtg-button-big">ACQUISTA CREDITI PER ACCEDERE A QUESTO SERVIZIO</a>-->
<!--        </span>-->
      </div>
    </div>
  </div>
</template>

<script>
import NBread from '@/partials/bread';
import {mapActions, mapState, mapMutations} from 'vuex';

export default {
  components: {
    NBread
  },
  computed: {
    ...mapState('n_compravendita', ['bread_active', 'bread_list', 'price']),
  },

  created() {
    this.SET_DATA({name: 'bread_active', data: {label: 'Servizio Atti di vendita'}});
    this.getPrice();
  },
  methods: {
    ...mapActions('n_compravendita', ['getPrice']),
    ...mapMutations('n_compravendita', ['SET_DATA']),
  }
}
</script>
